/* eslint-disable react/no-children-prop */
import React from "react";
import { Wrapper, Text } from "./styled";

const ButtonTextOnly = ({ text, background, color, onClick, disabled }) => {
  return (
    <Wrapper onClick={() => onClick()} disabled={disabled}>
      <Text children={text} background={background} color={color} />
    </Wrapper>
  );
};

export default ButtonTextOnly;
